import { businessColaboratorDto, businessColaboratorCreateDto } from '@/entities/businessColaborator';
import { BusinessColaboratorService } from '@/services/BusinessColaboratorService';
import { useEffect, useState } from 'react';

export function useBusinessColaborator(id: number) {
  const [colaboratorUse, setColaborator] = useState<businessColaboratorDto[]>([]);
  const [fetchBusinessColaboratorError, setFetchBusinessColaboratorError] = useState(false);
  const [createBusinessColaboratorError, setCreateBusinessColaboratorError] = useState(false);

  const fetchBusinessColaborator = async () => {
    try {
      const response = await BusinessColaboratorService.getColaboratorByBusiness(id);
      setColaborator(response);
      return(response);
    } catch (error) {
      console.error('Falha ao carregar dados de colaboradores: ', error);
      setFetchBusinessColaboratorError(true);
    }
  };

  useEffect(() => {
    fetchBusinessColaborator();
  }, []);

  const createBusinessColaborator = async (businessColaborator: businessColaboratorCreateDto): Promise<businessColaboratorDto | null> => {
    try {
      const response = await BusinessColaboratorService.createColaboratorBusiness({
        businessId: id,
        collaboratorId: businessColaborator.collaboratorId,
        isAdmin: businessColaborator.isAdmin,
      });
      if (response) {
        return response.data;
      }
    } catch (error) {
      console.error('Falha ao criar colaborador: ', error);
      setCreateBusinessColaboratorError(true);
    }
    return null;
  };

  const deleteBusinessColaborator = async (id: number, businessId: number) => {
    try {
      await BusinessColaboratorService.deleteColaboratorBusiness(id, businessId);
    } catch (error) {
      console.error('Falha ao deletar colaborador: ', error);
    }
  };

  return {
    colaboratorUse, 
    fetchBusinessColaboratorError,
    createBusinessColaboratorError,
    createBusinessColaborator,
    deleteBusinessColaborator,
    fetchBusinessColaborator,
  };
}
